
import { useEffect, useState } from "react";
import api from "../../../../../services/api";
import MessageSuccess from "../../../../../messages/messageSuccess";
import MessageError from "../../../../../messages/messageError";
import RegisterAccess from "../../../../../utils/registerAccess";
import HeaderSession from "../../../../../utils/headerSession";
import ButtonLeft from "../../../../../utils/buttonLeft";
import { Card, Checkbox, Container, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import * as yup from 'yup'; // VALIDACAO
import FichaSolicitacaoImportacao from "../fichaSolicitacaoImportacao";
import Loading from "../../../../../load/loading";
import { useDispatch } from "react-redux";
import PontosEntrada from "../../../../../utils/pontosEntrada";
import DocsMedicamentosControladosInternacionalmenteAnexo from "./desalfandegamentoDirecto/docsMedicamentosControladosInternacionalmenteAnexo";
import DocsMedicamentosControladosNacionaisAnexo from "./desalfandegamentoDirecto/docsMedicamentosControladosNacionaisAnexo";
import DocsMedicamentosNormalAnexo from "./desalfandegamentoDirecto/docsMedicamentosNormalAnexo";
import DocsSuplementoAlimentarAnexo from "./desalfandegamentoDirecto/docsSuplementoAlimentarAnexo";
import DocsEquipamentoAnexo from "./desalfandegamentoDirecto/docsEquipamentoAnexo";
import DocsReagentesTDRsAnexo from "./desalfandegamentoDirecto/docsReagentesTDRsAnexo";
import InputDocUpload from "../../../../../utils/inputFileUpload/inputDocUpload";
import AlertEdit from "../../../../../utils/alertEdit";


export default function FormSoliciteDesalfandegamento() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [solicitacao, setSolicitacao] = useState('')
    const [message, setMessage] = useState('')
    const [messageError, setErrorMessage] = useState('')
    const [open, setOpen] = useState(false)
    const { id } = useParams()
    const [solicitacaoImportacao, setSolicitacaoImportacao] = useState('')
    const imputLigth = true;
    const fullWidth = true;
    // console.log(useParams())

    useEffect(() => {
        api.get(`/solicitacao-importacao/${id}`)
            .then(response => {
                // console.log(response)
                setSolicitacaoImportacao(response.data.solicitacaoImportacao)
            }).catch(err => 'console.log(err)')
    }, [id])


    async function HandleChangeFile(file, name) {
        setSolicitacao((prevCadastro) => ({ ...prevCadastro, [name]: file }))
    }

    // function handleChange(e) {
    //     e.target.files ?
    //         setSolicitacao({ ...solicitacao, [e.target.name]: e.target.files[0] })
    //         :
    //         setSolicitacao({ ...solicitacao, [e.target.name]: e.target.value })
    // }

    function handleChange(e) {
        const { name, type, checked, value, files } = e.target;

        if (type === 'checkbox') {
            setSolicitacao({ ...solicitacao, [name]: checked });
        } else if (files) {
            setSolicitacao({ ...solicitacao, [name]: files[0] });
        } else {
            setSolicitacao({ ...solicitacao, [name]: value });
        }
    }

    async function createSolicitacaoDesalfandegamento() {
        const formData = new FormData();

        formData.append("numeroPorte", solicitacao?.numeroPorte)
        formData.append("numFatura", solicitacao?.numFatura)
        formData.append("destino", solicitacao?.destino)
        formData.append("pontoEntrada", solicitacao?.outroPontoEntrada ?? solicitacao?.pontoEntrada)
        formData.append("importadorId", solicitacaoImportacao.importador._id)
        formData.append("solicitacaoImportacaoId", id)
        formData.append("contemPC", solicitacao?.produtoControlado ?? false);
        formData.append("termolabeis2Ca8C", solicitacao?.termolabeis2Ca8C ?? false);
        formData.append("ate15C", solicitacao?.termolabiel_ate_15 ?? false);
        // formData.append("emolumentoId", "67b89a3a8d1b919f2318ed5c");

        // Docs
        formData.append("solicitacao", solicitacao?.solicitacao ?? '') // Carta	Solicitação dirigida à ARMED,
        formData.append("cartaPorteBl", solicitacao?.cartaPorteBl ?? '') // Carta de porte ou BL
        formData.append("certificadoCQL", solicitacao?.certificadoCQL ?? '') // Certificado de controlo de qualidade por lotes;
        formData.append("certificadoOP", solicitacao?.certificadoOP ?? '') // Certificado de Origem dos produtos;
        formData.append("CertificadoAnaliticoLote", solicitacao?.CertificadoAnaliticoLote ?? '') // 
        // formData.append("folhetoILP", solicitacao?.folhetoILP ?? '') // 
        formData.append("faturaFinal", solicitacao?.faturaFinal ?? '') // 
        formData.append("faturaEmolumento", solicitacao?.faturaEmolumento ?? '') // 

        if (solicitacao?.produtoControlado) {
            formData.append("certificadoExportacao", solicitacao?.certificadoExportacao ?? "");
            formData.append("certificadoProdutoControlado", solicitacao?.certificadoProdutoControlado ?? "");
        }


        setOpen(true);
        setErrorMessage('');
        setMessage('');

        await api.post('/declaracao-desalfandegamento/register', formData)
            .then(res => {
                setMessage(res.data.msg)
                dispatch({
                    type: 'alert',
                    payload: { alert: 'Solicitação foi enviada com sucesso.!' },
                });
                navigate(`/utente/solicitacao/importacao/${id}`)
                // console.log(res)
            }).catch(error => {
                setErrorMessage(error.response.data.message)
                // console.log(error)
            }).finally(() => setOpen(false))
    }

    async function validate() {
        setErrorMessage('');

        const schema = yup.object().shape({
            faturaEmolumento: yup
                .string("Necessário fazer o upload da Factura de pagamento de emolumento Armed")
                .required("Necessário fazer o upload da Factura de pagamento de emolumento Armed"),

            faturaFinal: yup
                .string("Necessário fazer o upload da Factura Final dos produtos importados, na língua portuguesa")
                .required("Necessário fazer o upload da Factura Final dos produtos importados, na língua portuguesa"),

            // folhetoILP: yup.string("Necessário fazer o upload dos folhetos informativos em língua portuguesa").required("Necessário fazer o upload dos folhetos informativos em língua portuguesa"),
            // certificadoOP: yup.string("Necessário fazer o upload do Certificado de Origem dos produtos").required("Necessário fazer o upload do Certificado de Origem dos produtos"),
            // certificadoCQL: yup.string("Necessário fazer o upload do Certificado de controlo de qualidade por lotes").required("Necessário fazer o upload do Certificado de controlo de qualidade por lotes"),
            // cartaPorteBl: yup.string("Necessário fazer o upload da Carta de porte ou BL").required("Necessário fazer o upload da Carta de porte ou BL"),
            // solicitacao: yup.string("Necessário fazer o upload da carta dirigida à Armed").required("Necessário fazer o upload da carta dirigida à Armed"),

            pontoEntrada: yup
                .string("Necessário selecionar o ponto de entrada")
                .required("Necessário selecionar o ponto de entrada"),

            destino: yup
                .string("Necessário selecionar o destino dos produtos")
                .required("Necessário selecionar o destino dos produtos"),

            numFatura: yup
                .string("Necessário inserir o número de factura emitida pela Armed")
                .required("Necessário inserir o número de factura emitida pela Armed"),

            numeroPorte: yup
                .string("Necessário inserir o número de porte")
                .required("Necessário inserir o número de porte"),

            // ➕ Validação condicional
            certificadoProdutoControlado: yup
                .string("Necessário fazer o upload do certificado de produto controlado")
                .when("produtoControlado", {
                    is: true,
                    then: schema =>
                        schema.required("Necessário fazer o upload do certificado de produto controlado"),
                    otherwise: schema => schema.notRequired()
                })
        });

        try {
            await schema.validate(solicitacao, { abortEarly: false });
            createSolicitacaoDesalfandegamento();
        } catch (error) {
            setErrorMessage(error.errors);
        }

        return false;
    }


    return (
        <div>
            <RegisterAccess page={'solicitação de desalfandegamento'} />

            <Container style={{ minHeight: '70vh' }}>
                <HeaderSession title={`SOLICITAÇÃO DE DESALFANDEGAMENTO`} />
                {message && <MessageSuccess message={message} />}
                {messageError && < MessageError message={messageError} />}

                {solicitacaoImportacao ?
                    <>
                        {solicitacao?.produtoControlado && <AlertEdit texto={'Caso não tenha o certificado de produto controlado deverá primeiro fazer a solicitação.'} />}

                        <FichaSolicitacaoImportacao solicitacaoImportacao={solicitacaoImportacao} />

                        <Typography variant="h5" m={2}>
                            Preenche o formulário:
                        </Typography>

                        <Card style={{ padding: 10 }}>

                            <Grid container>
                                <Grid xs={12} md item m>
                                    <TextField
                                        type="text"
                                        label="Nº de carta de porte/BL"
                                        fullWidth
                                        name="numeroPorte"
                                        variant="outlined"
                                        onChange={handleChange}
                                    />
                                </Grid>

                                <Grid xs={12} md item m>
                                    <TextField
                                        type="text"
                                        label="Nº da Factura (Emolumento Armed)"
                                        fullWidth
                                        name="numFatura"
                                        variant="outlined"
                                        onChange={handleChange}
                                    />
                                </Grid>
                            </Grid>


                            <Grid container>
                                <Grid xs={12} md item m>
                                    <PontosEntrada solicitacao={solicitacao} handleChange={handleChange} />
                                </Grid>

                                <Grid xs={12} md item m>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Destino</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Destino"
                                            name='destino'
                                            onChange={handleChange}
                                        // defaultValue={''}
                                        >
                                            {/* <MenuItem value="" disabled>...</MenuItem> */}
                                            <MenuItem value="Comercialização">Comercialização</MenuItem>
                                            <MenuItem value="Doação">Doação</MenuItem>
                                            {/* <MenuItem value="Uso pessoal">Uso Pessoal</MenuItem> */}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Grid container>
                                <Grid xs={12} md item m marginTop={2}>
                                    <FormControlLabel style={{ marginTop: '-12px' }} control={<Checkbox
                                        name="produtoControlado"
                                        onChange={handleChange}
                                        checked={solicitacao?.produtoControlado || false} />} label="Contém produto controlado"
                                    />
                                    <FormControlLabel style={{ marginTop: '-12px' }} control={<Checkbox
                                        name="termolabeis2Ca8C"
                                        onChange={handleChange}
                                        checked={solicitacao?.termolabeis2Ca8C || false} />} label="Termolábéis: 2• a 8•C"
                                    />
                                    <FormControlLabel style={{ marginTop: '-15px' }} control={<Checkbox
                                        name="termolabiel_ate_15"
                                        onChange={handleChange}
                                        checked={solicitacao?.termolabiel_ate_15 || false} />} label="Termolábéis atê 15•C"
                                    />
                                </Grid>
                            </Grid>

                            {/* ANEXAR DOCUMENTOS */}
                            <Typography align="center" m={2} color={'secondary'}>ANEXAR DOCUMENTOS </Typography>

                            {solicitacaoImportacao?.tipoCertificado === 'Produtos-de-controle-internacional' &&
                                <DocsMedicamentosControladosInternacionalmenteAnexo HandleChangeFile={HandleChangeFile} />
                            }
                            {solicitacaoImportacao?.tipoCertificado === 'Produtos-de-controle-Nacional' &&
                                <DocsMedicamentosControladosNacionaisAnexo HandleChangeFile={HandleChangeFile} />
                            }
                            {solicitacaoImportacao?.tipoCertificado === 'Medicamentos' &&
                                <DocsMedicamentosNormalAnexo HandleChangeFile={HandleChangeFile} />
                            }
                            {solicitacaoImportacao?.tipoCertificado === 'Suplemento-Alimentar' &&
                                <DocsSuplementoAlimentarAnexo HandleChangeFile={HandleChangeFile} />
                            }
                            {solicitacaoImportacao?.tipoCertificado === 'Equipamento' &&
                                <DocsEquipamentoAnexo HandleChangeFile={HandleChangeFile} />
                            }
                            {solicitacaoImportacao?.tipoCertificado === 'Reagentes-TDRs' &&
                                <DocsReagentesTDRsAnexo HandleChangeFile={HandleChangeFile} />
                            }

                            {/* CASO EXISTRIR PRODUTO CONTROLADO NA SOLICITACAO */}
                            {solicitacao?.produtoControlado &&
                                <Grid container>
                                    <Grid xs={12} md item>
                                        <InputDocUpload
                                            imputLigth={imputLigth}
                                            fullWidth={fullWidth}
                                            onFileSelect={HandleChangeFile}
                                            inputName={'certificadoProdutoControlado'}
                                            inputDescription={'Certificado de produto controlado'}
                                            inputTitle={'Certificado de produto controlado'}
                                        />
                                    </Grid>

                                    <Grid xs={12} md item>
                                        <InputDocUpload
                                            imputLigth={imputLigth}
                                            fullWidth={fullWidth}
                                            onFileSelect={HandleChangeFile}
                                            inputName={'certificadoExportacao'}
                                            inputDescription={'Certificado de exportação'}
                                            inputTitle={'Certificado de exportação (Se aplicavel)'}
                                        />
                                    </Grid>
                                </Grid>
                            }

                            <ButtonLeft title={'Submeter'} funcao={validate} disabled={!solicitacao || open} load={open} />
                        </Card>
                    </>
                    :
                    <Loading />
                }

            </Container>
            <br />
        </div>
    );
}
